module.exports = __webpack_public_path__ + "static/media/air-flap-1.601a9fb3.png";